import { gql } from '@apollo/client';

export const PERMIT_COMMON_FIELDS = gql`
   fragment PermitCommonFields on Permit {
      id
      applicationNumber
      applicationType
      status
      currentStage
      requestType
      dateOfSubmission

      # Staff acceptance flags
      acceptedByTechnicalStaff
      approvedByTechnicalStaff
      acceptedByReceivingClerk
      recordedByReceivingClerk
      recordedByReleasingClerk
      acceptedByPENRCENROfficer
      approvedByPENRCENROfficer
      reviewedByChief

      # Process state flags
      awaitingOOP
      OOPCreated
      hasInspectionReport
      isInspectionResultPassed
      InspectionReportsReviewedByChief
      InspectionReportsReviewedByPENRCENROfficer
      awaitingPermitCreation
      PermitCreated

      # Certificate related flags
      certificateSignedByPENRCENROfficer
      certificateSignedByForestRanger
      certificateSignedByChiefTSD
      ApprovedInventoryRequest
      certificateId
      hasCertificate

      # Assignment info
      assignedTechnicalStaffId
      assignedTechnicalStaffName
      assignmentDate

      # History
      history {
         stage
         status
         timestamp
         notes
         actionBy
      }

      # Renewal history
      renewalHistory {
         id
         renewalDate
         previousExpiryDate
         newExpiryDate
         renewedBy {
            id
         }
      }
   }
`;

export const COV_PERMIT_FIELDS = gql`
   fragment COVPermitFields on COVPermit {
      id
      name
      address
      cellphone
      purpose
      driverName
      driverAddress
      driverLicenseNumber
      vehiclePlateNumber
      originAddress
      destinationAddress
      files {
         letterOfIntent { filename contentType }
         tallySheet { filename contentType }
         forestCertification { filename contentType }
         orCr { filename contentType }
         driverLicense { filename contentType }
         specialPowerOfAttorney { filename contentType }
      }
   }
`;

export const CSAW_PERMIT_FIELDS = gql`
   fragment CSAWPermitFields on CSAWPermit {
      id
      registrationType
      chainsawStore
      ownerName
      address
      phone
      purpose
      brand
      model
      serialNumber
      dateOfAcquisition
      powerOutput
      maxLengthGuidebar
      countryOfOrigin
      purchasePrice
      isOwner
      isTenureHolder
      isBusinessOwner
      isPTPRHolder
      isWPPHolder
      files {
         officialReceipt { filename contentType }
         deedOfSale { filename contentType }
         specialPowerOfAttorney { filename contentType }
         forestTenureAgreement { filename contentType }
         businessPermit { filename contentType }
         certificateOfRegistration { filename contentType }
         woodProcessingPlantPermit { filename contentType }
      }
   }
`;

export const PTPR_PERMIT_FIELDS = gql`
   fragment PTPRPermitFields on PTPRPermit {
      id
      ownerName
      address
      contactNumber
      lotArea
      treeSpecies
      totalTrees
      treeSpacing
      yearPlanted
      isCLOA
      isRepresentative
      files {
         letterRequest { filename contentType }
         titleOrTaxDeclaration { filename contentType }
         darCertification { filename contentType }
         specialPowerOfAttorney { filename contentType }
      }
   }
`;

export const PLTCP_PERMIT_FIELDS = gql`
   fragment PLTCPPermitFields on PLTCPPermit {
      id
      name
      address
      contactNumber
      requestType
      treeType
      treeStatus
      landType
      posingDanger
      forPersonalUse
      purpose
      isWithinSubdivision
      isSchoolOrOrganization
      occupation
      projectLocation
      projectAddress
      files {
         letterOfIntent { filename contentType }
         applicationLetter { filename contentType }
         lguEndorsement { filename contentType }
         homeownersResolution { filename contentType }
         ptaResolution { filename contentType }
      }
   }
`;

export const PLTP_PERMIT_FIELDS = gql`
   fragment PLTPPermitFields on PLTPPermit {
      id
      name
      address
      contactNumber
      requestType
      treeType
      treeStatus
      landType
      posingDanger
      forPersonalUse
      purpose
      isCLOA
      isRepresentative
      isSchoolOrOrganization
      files {
         letterOfIntent { filename contentType }
         applicationLetter { filename contentType }
         lguEndorsement { filename contentType }
         titleCertificate { filename contentType }
         darCertificate { filename contentType }
         specialPowerOfAttorney { filename contentType }
         ptaResolution { filename contentType }
      }
   }
`;

export const TCEBP_PERMIT_FIELDS = gql`
   fragment TCEBPPermitFields on TCEBPPermit {
      id
      name
      projectLocation
      officeName
      officeAddress
      contactNumber
      purpose
      isWithinTimberland
      isTitledProperty
      isWithinProtectedArea
      isRequestForCutting
      isRequestForEarthBalling
      files {
         letterOfIntent { filename contentType }
         applicationLetter { filename contentType }
         lguEndorsement { filename contentType }
         landTenurial { filename contentType }
         siteDevelopmentPlan { filename contentType }
         environmentalCompliance { filename contentType }
         fpic { filename contentType }
         ownerConsent { filename contentType }
         pambClearance { filename contentType }
      }
   }
`;